import { render, staticRenderFns } from "./vRemisiones.vue?vue&type=template&id=3e5edcc8"
import script from "./vRemisiones.vue?vue&type=script&lang=js"
export * from "./vRemisiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports